/**
 * Live Fleet Map UX copy (Wave 2.12) — empty / error / outage states.
 * Map vendor failure must never block list fallback.
 */

export const PMV_MAP_EMPTY = {
  noConnectedLocation:
    'No connected equipment currently has a location.',
  noAuthorizedAccess:
    'No fleet locations are available for your current access.',
  filterEmpty:
    'No equipment matches these map filters.',
  providerDelayed:
    'Location updates are delayed. Showing last known positions where available.',
} as const;

export const PMV_MAP_ERROR = {
  imageryUnavailable:
    'Map imagery is unavailable. Fleet location data remains available in list view.',
  dataLoadFailed:
    'Could not load fleet map data. Check Connected Fleet permissions and kill switch.',
} as const;

export const PMV_MAP_LEGEND = [
  { key: 'live', label: 'Live position', hint: 'Recent good GPS' },
  { key: 'delayed', label: 'Delayed', hint: 'Still reporting, aged' },
  { key: 'stale', label: 'Last known / offline', hint: 'Not current presence' },
  { key: 'moving', label: 'Moving', hint: 'Movement state' },
  { key: 'attention', label: 'Attention', hint: 'Open spatial case' },
  { key: 'selected', label: 'Selected', hint: 'List ↔ map sync' },
] as const;

export function fleetMapEmptyMessage(input: {
  isError?: boolean;
  unauthorizedHint?: boolean;
  listRows: number;
  hasFilters: boolean;
  delayedCount?: number;
  liveCount?: number;
}): string | null {
  if (input.isError) return null;
  if (input.unauthorizedHint) return PMV_MAP_EMPTY.noAuthorizedAccess;
  if (input.listRows === 0 && input.hasFilters) return PMV_MAP_EMPTY.filterEmpty;
  if (input.listRows === 0) return PMV_MAP_EMPTY.noConnectedLocation;
  if (
    (input.liveCount ?? 0) === 0 &&
    (input.delayedCount ?? 0) > 0
  ) {
    return PMV_MAP_EMPTY.providerDelayed;
  }
  return null;
}
